var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.3125L25 9.4375L14 3L3 9.4375L14 16.3125ZM27.3125 9.6875V23C27.3125 23.7083 27.0417 24.3333 26.5 24.875C26 25.4167 25.3958 25.6875 24.6875 25.6875H3.3125C2.60417 25.6875 1.97917 25.4167 1.4375 24.875C0.9375 24.3333 0.6875 23.7083 0.6875 23V9.6875C0.6875 8.64583 1.10417 7.875 1.9375 7.375L14 0.3125L26.0625 7.375C26.8958 7.875 27.3125 8.64583 27.3125 9.6875Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpen);
export default __webpack_public_path__ + "static/media/mail_open.80602a287cd59f993996fcda9eca9c41.svg";
export { ForwardRef as ReactComponent };